import { useLocation } from 'react-router-dom';

import { defineLanguage } from './utils';

export const useLanguageChecker = () => {
  const { pathname } = useLocation();

  defineLanguage(pathname);
};
